var exports = {
  "p": "x4c3adb35--3843df--list",
};

module.exports = exports;
